import { render, staticRenderFns } from "./VModalMobileOnly.vue?vue&type=template&id=5a1df572&scoped=true&"
import script from "./VModalMobileOnly.vue?vue&type=script&lang=js&"
export * from "./VModalMobileOnly.vue?vue&type=script&lang=js&"
import style0 from "./VModalMobileOnly.vue?vue&type=style&index=0&id=5a1df572&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1df572",
  null
  
)

export default component.exports